/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import $ from 'jquery';
window.$ = window.jQuery = $;
import 'bootstrap';

import { TempusDominus } from '@eonasdan/tempus-dominus';
// make accessible if you init from inline script
window.TempusDominus = TempusDominus;